import React from 'react';

import Hero from '../../components/Hero/Hero';
import Page from '../../components/Page/Page';
import Advantages from './Advantages/Advantages';
import BenefitsOfLocum from './BenefitsOfLocum/BenefitsOfLocum';
import HowItWorks from './HowItWorks/HowItWorks';

const LookingForWork = () => {
  return (
    <Page title="LocumSpace | Looking for work?">
      <Hero
        imgSrc="/static/img/looking-for-work-hero.png"
        title="Take Control of Your Schedule. Work on Your Terms"
        description="Decide when and where you work. Whether you’re looking for extra shifts, flexible locum opportunities, or a better work-life balance, we put the power in your hands."
      />
      <BenefitsOfLocum />
      <HowItWorks />
      <Advantages />
    </Page>
  );
};

export default LookingForWork;
